import { render } from "./DonationSettings.vue?vue&type=template&id=1cff79d2&scoped=true"
import script from "./DonationSettings.vue?vue&type=script&lang=js"
export * from "./DonationSettings.vue?vue&type=script&lang=js"

import "./DonationSettings.vue?vue&type=style&index=0&id=1cff79d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cff79d2"]])

export default __exports__